<template>
  <div class="headerWrap">
    <div class="homeHeader">
      <div class="inner">
        <div class="left">
          <div class="title">
            <img class="logo" v-if="schoolLogo" :src="schoolLogo" alt="logo" />
            <div class="line" v-if="schoolLogo"></div>
            <div class="name">{{ systemName }}</div>
          </div>
          <div class="nav" v-if="rsign == 'student'">
            <ul>
              <li
                v-for="(item, index) in navList"
                :key="index"
                :class="isActive(item, index) ? 'active' : ''"
                v-if="item.uType == 1"
              >
                <a @click="toNav(item)">{{ item.name }}</a>
              </li>
            </ul>
          </div>
          <div class="nav" v-if="rsign == 'teacher'">
            <ul>
              <li
                v-for="(item, index) in navList"
                :key="index"
                :class="isActive(item, index) ? 'active' : ''"
                v-if="item.uType == 2"
              >
                <a @click="toNav(item)">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="operation">
          <div class="item">
            <a-dropdown placement="bottomCenter">
              <a class="ant-dropdown-link">
                <img class="user" :src="avatar" alt="user" v-if="avatar" />
                <img
                  v-else
                  class="user"
                  :src="require('@/assets/home/avatar.png')"
                  alt="user"
                />

                {{ userName }}（{{ phone }}）
                <a-icon type="caret-down" theme="filled" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <div @click="toMine(0)">账号修改</div>
                </a-menu-item>
                <a-menu-item>
                  <div @click="toMine(1)">密码修改</div>
                </a-menu-item>
                <a-menu-item>
                  <div @click="toLogout">退出登录</div>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div v-if="breadNav" class="breadNav">
      <div class="inner">
        <span>当前位置：</span>
        <span class="home" @click="toHome">首页</span>
        <span class="line">/</span>
        <span class="cur">{{ pageTitle }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { logOut } from "@/api/api";
import { getFlag } from "@/api/common";

export default {
  props: {
    activeIndex: {
      // 当前选中
      type: String,
    },
    pageTitle: {
      // 标题名称
      type: String,
    },
    breadNav: {
      // 是否显示--面包屑
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      userName: "",
      phone: "",
      navList: [
        // { name: "首页", path: "/home", flag: 1 },
        // { name: "单招报名确认", path: "/singUp", flag: 2 },
        // { name: "报名查看", path: "/singUpLook", flag: 3 },
        // { name: "通知公告", path: "/notice", flag: 1 },
        // { name: "校园Q&A", path: "/qa", flag: 1 },
      ],
      systemName: localStorage.getItem("systemName"),
      schoolLogo: localStorage.getItem("schoolLogo"),
      avatar: "",
      signUpFlag: false, // 单招报名确认
      signUpLookFlag: false, // 报名查看
      tip1: "功能暂未开启", // 单招报名确认
      tip2: "功能暂未开启", // 报名查看
      rsign: "",
      menuStu: { name: "首页", path: "/home", flag: 1, uType: 1 },
      menuTea: { name: "首页", path: "/home", flag: 1, uType: 2 },
    };
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("user"));

    this.rsign = userInfo.rsign;
    this.navList = (userInfo.menuList || []).filter(
      (item) => item && item.mcode !== "arrivalIntent"
    );
    this.avatar = userInfo.stuPhoto;
    if (this.rsign == "student") {
      this.navList.unshift(this.menuStu);
    } else {
      this.navList.unshift(this.menuTea);
    }

    console.log(userInfo, this.navList, "21238238238");
    if (userInfo) {
      this.userName = userInfo.name;
      this.phone = userInfo.loginname;
    }
    this.getFlagAll();
  },
  methods: {
    isActive(item, index) {
      const routeCode = this.resolveRouteCode();
      const itemCode = this.getItemCode(item);
      if (routeCode && itemCode) {
        return routeCode === itemCode;
      }
      return String(this.activeIndex) === String(index);
    },
    getItemCode(item) {
      if (!item) {
        return "";
      }
      if (item.path === "/home") {
        return "home";
      }
      return item.mcode || "";
    },
    resolveRouteCode() {
      const path = this.$route && this.$route.path ? this.$route.path : "";
      if (!path) {
        return "";
      }
      if (path === "/home") {
        return "home";
      }
      if (path === "/singUp") {
        return "signUp";
      }
      if (path === "/arrivalIntent") {
        return "arrivalIntent";
      }
      if (path === "/singUpLook" || path === "/fractionLook") {
        return "signUpQuery";
      }
      if (path === "/notice" || path === "/noticeDetail") {
        return "notice";
      }
      if (path === "/qa" || path === "/qaDetail") {
        return "qa";
      }
      return "";
    },
    toNav(item) {
      console.log(this.activeIndex, "218239329239");
      if (item.mcode == "signUp") {
        if (this.signUpFlag) {
          this.$router.push({
            // path: item.path,
            path: "/singUp",
          });
        } else {
          this.$message.info(this.tip1 ? this.tip1 : "功能暂未开启");
        }
      } else if (item.mcode == "signUpQuery") {
        if (this.signUpLookFlag) {
          this.$router.push({
            path: "/singUpLook",
          });
        } else {
          this.$message.info(this.tip2 ? this.tip2 : "功能暂未开启");
        }
      } else if (item.mcode == "qa") {
        this.$router.push({
          path: "/qa",
        });
      } else if (item.mcode == "notice") {
        this.$router.push({
          path: "/notice",
        });
      } else if (item.mcode == "arrivalIntent") {
        this.$router.push({
          path: "/arrivalIntent",
        });
      } else {
        this.$router.push({
          path: "/home",
        });
      }
      // if (item.flag == 1) {
      //   this.$router.push({
      //     path: item.path,
      //   });
      // } else {
      //   if (item.flag == 2) {
      //     if (this.signUpFlag) {
      //       this.$router.push({
      //         path: item.path,
      //       });
      //     } else {
      //       this.$message.info(this.tip1 ? this.tip1 : "功能暂未开启");
      //     }
      //   }
      //   if (item.flag == 3) {
      //     if (this.signUpLookFlag) {
      //       this.$router.push({
      //         path: item.path,
      //       });
      //     } else {
      //       this.$message.info(this.tip2 ? this.tip2 : "功能暂未开启");
      //     }
      //   }
      // }
    },
    toHome() {
      this.$router.push({
        path: "/home",
      });
    },
    toMine(cur) {
      this.$router.push({
        path: "/mine",
        query: {
          curTab: cur,
        },
      });
    },
    getFlagAll() {
      // 报名---大块
      getFlag({
        paramKey: "signup2",
        uvCode: localStorage.getItem("uvCode"),
      }).then((res) => {
        this.tip1 = res.paramHint;
        if (res.paramStatus == "1") {
          this.signUpFlag = true;
        } else {
          this.signUpFlag = false;
        }
      });
      // 报名查看---大块
      getFlag({
        paramKey: "signupLook2",
        uvCode: localStorage.getItem("uvCode"),
      }).then((res) => {
        this.tip2 = res.paramHint;
        if (res.paramStatus == "1") {
          this.signUpLookFlag = true;
        } else {
          this.signUpLookFlag = false;
        }
      });
    },
    toLogout() {
      const _this = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          logOut().then((res) => {
            if (res.code == 0) {
              // this.$message.success(res.msg);
              _this.$message.success("注销登录成功");
              const uvCode = localStorage.getItem("uvCode");
              localStorage.clear();
              setTimeout(() => {
                _this.$router.push({
                  name: "Login",
                  query: {
                    uvCode: uvCode,
                  },
                });
              }, 1000);
            } else {
              _this.$message.error(res.msg);
            }
          });
        },
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.headerWrap {
  width: 100%;
}
.homeHeader {
  width: 100%;
  height: 64px;
  background: #2a79ff;
  .inner {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 64px;
  }
  .left {
    display: flex;
    align-items: center;
    flex: 1;
  }
  .nav {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
    margin-left: auto;
    ul {
      list-style: none;
      display: flex;
      margin: 0;
      padding-left: 0;
      li {
        font-size: 14px;
        margin-right: 20px;
        margin-top: 4px;
        line-height: 56px;
        a {
          color: rgba(255, 255, 255, 0.75);
          text-decoration: none;
          display: block;
          width: 100%;
        }
      }
      .active {
        font-weight: 600;
        border-bottom: 4px solid #fff;
        a {
          color: #fff;
        }
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    margin-right: 55px;
    .logo {
      height: 36px;
    }
    .name {
      font-size: 20px;
      font-weight: 600;
      color: #fff;
    }
    .line {
      width: 1px;
      height: 26px;
      border-right: 1px solid rgba(255, 255, 255, 0.6);
      margin: 0px 16px;
    }
  }
  .operation {
    display: flex;
    .item {
      position: relative;
      a {
        color: #fff;
      }
      .user {
        width: 32px;
        height: 32px;
        margin-right: 8px;
      }
    }
  }
}
.breadNav {
  width: 100%;
  height: 48px;
  background: #fff;
  .inner {
    width: 1200px;
    margin: 0 auto;
    line-height: 48px;
    font-size: 14px;
    color: #999;
    .home {
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
    }
    .line {
      color: rgba(0, 0, 0, 0.45);
      padding: 0 8px;
    }
    .cur {
      color: rgba(0, 0, 0, 0.65);
    }
  }
}
</style>
